import Amplify, { Auth, Hub, API } from 'aws-amplify';
import awsconfig from './aws-exports';
import React, { Component } from 'react';
import { Authenticator } from 'aws-amplify-react';
import logo from './logo.svg';
import './App.css';

awsconfig.oauth.domain = "federated.corsava.com";

// awsconfig.aws_cloud_logic_custom = awsconfig.aws_cloud_logic_custom.map(custom => {
//   custom.custom_header = async () => {
//     return { jwtToken : this.state.jwtToken }
//     // Alternatively, with Cognito User Pools use this:
//     // return { Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}` }
//   }
// });

Amplify.configure(awsconfig);

console.log(API);

class App extends Component {
  state = { user: null, customState: null };

  componentDidMount() {

    Hub.listen("auth", ({ payload: { event, data } }) => {

      console.log(`${event}: ${JSON.stringify(data)}`);
      switch (event) {
        case "signIn":
          this.setState({ user: data });
          break;
        case "signOut":
          this.setState({ user: null });
          break;
        case "customOAuthState":
          this.setState({ customState: data });
      }
    });

    var urlParams = new URLSearchParams(window.location.search);

    if(!urlParams.get("code")) {
      Auth.currentAuthenticatedUser()
        .then(authuser => {

          this.setState({ authuser, jwtToken: authuser.signInUserSession.idToken.jwtToken });



          this.FetchData(authuser);
        })
        .catch((e) => {
          console.log(e);
          console.log("Not signed in")
        });

    }
  }

  async FetchData(user) {
    let apiName = 'InternalMetrics';
    let path = '/stats';
    let myInit = {
        headers: { Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}` },
        response: true
    }
    API.get(apiName, path, myInit).then(response => {
        console.log(response);
    }).catch(error => {
        console.log(error.response)
    });
  }

  render() {
    const { user, authuser } = this.state;

    return (
      <div className="App">
        {(!user && !authuser) &&
          <div>
            <button onClick={() => Auth.federatedSignIn()}>Hosted Sign In</button>
          </div>
        }
        {(user || authuser) &&
          <div>
            <button onClick={() => Auth.signOut()}>Sign Out</button>
          </div>
        }
        {this.state.authuser &&
          <div>
            <strong>currentAuthenticatedUser:</strong>
            <pre>
              {JSON.stringify(this.state.authuser, null, 2)}
            </pre>
          </div>
        }
        <pre>
          <strong>Current Session:</strong>
          {JSON.stringify(this.state.sessions, null, 2)}
        </pre>
        <pre>
          <strong>Current Creds:</strong>
          {JSON.stringify(this.state.creds, null, 2)}
        </pre>

      </div>
    );
  }
}

export default App;
